<script setup>
import {ref, watch, nextTick} from "vue";
import {useStripe} from "@/composables/useStripe";

const emit = defineEmits(["closed"]);
const showModal = ref(false);

const cardholderName = ref('');
const zipCode = ref('');
const cardError = ref('');

let stripe = null;
let cardNumber = null;
let cardExpiry = null;
let cardCvc = null;

watch(showModal, async value => {
    if (!value) {
        emit("closed");
        return;
    }

    await nextTick();

    stripe = await useStripe();
    const elements = stripe.elements();

    const style = {
        base: { fontSize: '16px', color: '#32325d' }
    };

    cardNumber = elements.create('cardNumber', { style });
    cardNumber.mount('#stripe-card-number');

    cardExpiry = elements.create('cardExpiry', { style });
    cardExpiry.mount('#stripe-card-expiry');

    cardCvc = elements.create('cardCvc', { style });
    cardCvc.mount('#stripe-card-cvc');
})

async function submit() {
    cardError.value = '';

    const { token, error } = await stripe.createToken(cardNumber, {
        name: cardholderName.value,
        address_zip: zipCode.value,
    });

    if (error) {
        cardError.value = error.message;
        return;
    }

    console.log(token.id);
}

function open() {
    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <Modal v-model="showModal" hide-footer hide-header modal-class="modal-upsell-payment">
        <form class="form-v2">
            <div class="modal-upsell-payment__card">
                <h4 class="heading4 heading5--secondary">Upgrade to SwitchPitch Pro</h4>

                <p>Need a payment request? <a href="#">Send Invoice Instead</a></p>

                <fieldset>
                    <legend>card details</legend>

                    <div class="form-v2__item">
                        <label>Cardholder Name</label>
                        <input type="text" v-model="cardholderName" />
                    </div>

                    <div class="form-v2__item">
                        <label>Card Number</label>
                        <div id="stripe-card-number"></div>
                    </div>

                    <div class="form-v2__item-cols">
                        <div class="form-v2__item">
                            <label>Exp Date</label>
                            <div id="stripe-card-expiry"></div>
                        </div>
                        <div class="form-v2__item">
                            <label>CVV</label>
                            <div id="stripe-card-cvc"></div>
                        </div>
                    </div>

                    <div class="form-v2__item">
                        <label>Zip Code</label>
                        <input type="text" v-model="zipCode" />
                    </div>

                    <div v-if="cardError" class="form-error">{{ cardError }}</div>
                </fieldset>

                <div class="modal-upsell-payment-note">Secure payment by Stripe</div>
            </div>

            <fieldset class="modal-upsell-payment__plan">
                <header class="modal-header">
                    <h6 class="heading6">Your Plan</h6>
                    <button type="button" @click="showModal = false" class="close"></button>
                </header>

                <h5 class="heading5">SwitchPitch Pro</h5>

                <div class="plan-option selected">
                    <div class="radio checked" id="r-quarterly"></div>
                    <div class="plan-info">
                        <div class="plan-name">Quarterly</div>
                        <p>Billed every 3 months</p>
                    </div>
                    <div class="plan-price">$3,750</div>
                </div>

                <div class="plan-option">
                    <div class="radio" id="r-annual"></div>
                    <div class="plan-info">
                        <div class="plan-name">Annual <span class="save-badge">Save 20%</span></div>
                        <p>Billed once per year</p>
                    </div>
                    <div class="plan-price">$12,000</div>
                </div>

                <div class="plan-summary">
                    <div class="plan-summary__row"><span>Subtotal</span><span id="subtotal">$3,750</span></div>
                    <div class="plan-summary__row"><span>Estimated taxes</span><span id="taxes">$14</span></div>
                </div>

                <div class="plan-total-row"><span>Total</span><span>$3,764</span></div>

                <button type="button" class="ui-button w-100" @click="submit">Submit Payment</button>
            </fieldset>
        </form>

        <!-- <div class="modal-content__inner"></div> -->
    </Modal>
</template>

<style scoped>

</style>
